<template>
  <div ref="root" class="rounded-lg bg-[#F4F0EB] p-32 md:text-center">
    <WarrantyTag class="mb-32" />

    <p class="body-2-bold mb-12 text-center">
      {{ i18n(translations.delay) }}
    </p>
    <h2 class="punchline mb-32 text-center">
      {{ i18n(translations.title) }}
    </h2>

    <p class="body-2 mb-24">
      {{ i18n(translations.content) }}
    </p>
    <p class="body-2">
      {{ i18n(translations.hours) }}
    </p>
    <p class="body-2">
      {{ i18n(translations.phone) }}
    </p>
  </div>
</template>

<script lang="ts" setup>
import { onUnmounted, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { useIntersectionObserver } from '@vueuse/core'

import WarrantyTag from '../WarrantyTag/WarrantyTag.vue'

import translations from './ReassuranceCustomerSupport.translations'

const i18n = useI18n()

const { trackProductBlockImpression } = useTracking()
const root = ref<HTMLElement | null>()

const { stop } = useIntersectionObserver(root, ([{ isIntersecting }]) => {
  if (isIntersecting) {
    trackProductBlockImpression({
      block_name: 'reassurance_support_block',
    })
    stop()
  }
})

onUnmounted(() => {
  stop()
})
</script>
